import { Injectable } from '@angular/core';
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { mergeMap, tap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { getCurrencySymbol } from "@angular/common";

interface ICurrencyOptions {
    [key: string]: string[];
}

export interface ICurrencyOption {
    value: string;
    label: string;
}

@Injectable()
export class CurrencyListResourceService {

    private options: Map<string, ICurrencyOption[]> = new Map<string, ICurrencyOption[]>();

    private defaultConfiguration: ICurrencyOptions = {
        "EUR": [
            "EUR",
            "USD",
            "CAD"
        ],
        "USD": [
            "USD",
            "EUR"
        ],
        "CAD": [
            "CAD",
            "EUR"
        ]
    };

    constructor(
        private readonly configurationResourceService: ConfigurationResourceService,
    ) {
    }

    public getCurrencyOption(currency: string): Observable<ICurrencyOption[]> {
        if (this.options.has(currency)) {
            return of(this.options.get(currency));
        }
        return this.getCurrencyConfiguration(currency);
    }

    public getOptionsFromCodes(currencyCodes: string[]): ICurrencyOption[] {
        return currencyCodes.map((currencyCode: string) => ( {value: currencyCode, label: getCurrencySymbol(currencyCode, "wide") }) );
    }

    private getCurrencyConfiguration(currency: string): Observable<ICurrencyOption[]> {
        return this.configurationResourceService
            .get(['wui', 'shared_quotation', 'config', 'currencies', 'currencies.json'], this.defaultConfiguration)
            .pipe(
                mergeMap((configuration: ICurrencyOptions) => {
                    Object.entries(configuration)
                        .forEach(([key, value]: [string, string[]]) => {
                            const options: ICurrencyOption[] = this.getOptionsFromCodes(value);
                            this.options.set(key, options);
                        });
                    return of(this.options.get(currency));
                })
            );

    }
}